/**
 * EmptyState Component
 *
 * Reusable empty state display for tables and lists.
 */

import React from "react";
import { emptyStateStyles } from "../styles";

const EmptyState = ({ message }) => (
  <div style={emptyStateStyles.container}>
    <p style={emptyStateStyles.text}>{message}</p>
  </div>
);

export default EmptyState;
